<div class="grid md:grid-cols-4 sm:grid-cols-1 gap-2 mb-2">
  <div class="col-span-1 flex gap-2 items-baseline">
    <app-pan-form-control class="w-full">
      <app-pan-floating-label> Period </app-pan-floating-label>
      <app-pan-datepicker
        [(date)]="monthAndYear"
        placeholder="Select month/year"
        startView="multi-year"
        (monthSelected)="closeDatePickerEarly($event)"
      />
    </app-pan-form-control>
  </div>
</div>

<app-pan-inline-alert class="my-2" type="info">Double-click on a shrink value to edit it</app-pan-inline-alert>

<ag-grid-angular #reportGrid [rowData]="shrinkData()" [columnDefs]="columnDefs" [gridOptions]="tableDef"></ag-grid-angular>

<app-pan-modal #addModal [topLevel]="false">
  <div header>Add Location Shrink</div>

  <div body class="flex flex-col gap-2">
    <app-pan-form-control>
      <app-pan-floating-label>Location</app-pan-floating-label>
      <ng-select
        appendTo="body"
        placeholder="Select location"
        [bindLabel]="'name'"
        [virtualScroll]="true"
        [items]="selectableShrinkLocations()"
        [(ngModel)]="shrinkAddLocation"
      >
      </ng-select>
    </app-pan-form-control>

    <app-pan-form-control>
      <app-pan-floating-label>Shrink %</app-pan-floating-label>
      <input panInput panNumericInput type="number" [(ngModel)]="shrinkAddPercentage" placeholder="Enter shrink percentage" />
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>

    <app-pan-button
      panModalClose
      class="me-2 mb-2"
      [color]="'primary'"
      (click)="addLocationShrink()"
      [disabled]="!shrinkAddLocation()"
      icon="add"
    >
      Add Shrink
    </app-pan-button>
  </div>
</app-pan-modal>
